import React from 'react';

import * as Styled from './ButtonRect.styles';

import { ReactComponent as InteriorSVG } from "../../svg/seat-icon.svg";
import { ReactComponent as ExteriorSVG } from "../../svg/car-icon.svg";
import { ReactComponent as StarsSVG } from "../../svg/stars-icon.svg";
import { colors } from 'utils/styles/theme';
import Counter from 'components/Counter/Counter';

export interface ButtonRectProps {
  onAction: () => void;
  label: string;
  variant: 'interior' | 'exterior' | 'event' | 'countdown';
}

const ButtonRect: React.FC<ButtonRectProps> = ({
  onAction,
  label,
  variant
}) => {
  return <Styled.Wrapper className={variant === "countdown" ? 'countdown' : ''} onClick={(e) => {
    e.stopPropagation();
    e.preventDefault();
    onAction(); 
  }} style={{
    border: (variant === 'event' || variant === 'countdown') ? `1px solid ${colors.red}` : `1px solid ${colors.white}`
  }}>
    {(variant === 'event'  || variant === 'countdown') && <>
      <div className="animated-border-box-glow" />
      <div className="animated-border-box" />
      <div className="animated-border-box-particles" />
      <div className="animated-border-box-particles-move" /> 
    </>}
    <Styled.Icon>{
      variant === 'interior' ? <InteriorSVG /> : variant === 'exterior' ? <ExteriorSVG /> :  variant === 'event' ? <StarsSVG /> : <></>
    }</Styled.Icon>
    {variant !== "countdown" ? (<Styled.Label dangerouslySetInnerHTML={{ __html: label }} />) : (
      <Styled.Counter>
        <Styled.Label dangerouslySetInnerHTML={{ __html: label }} />
        <Counter />
      </Styled.Counter>
    )}
  </Styled.Wrapper>;
};

export default ButtonRect;
